export const endpoints = {
  RegisterEmail: process.env.REACT_APP_ENDPOINT_REGISTER_EMAIL ?? '',
  VerifyEmail: process.env.REACT_APP_ENDPOINT_VERIFY_EMAIL ?? '',
  Diversity: process.env.REACT_APP_ENDPOINT_DIVERSITY_CLASSIFICATION ?? '',
  SubmitRegistration: process.env.REACT_APP_ENDPOINT_SUBMIT ?? '',
  Products: process.env.REACT_APP_ENDPOINT_PRODUCTS ?? '',
  CompanyInfo: process.env.REACT_APP_ENDPOINT_COMPANYINFO ?? '',
  Countries: process.env.REACT_APP_ENDPOINT_LOCATION_COUNTRIES ?? '',
  StateProvince: process.env.REACT_APP_ENDPOINT_LOCATION_STATEPROVINCE ?? '',
  CompanyAddresses: process.env.REACT_APP_ENDPOINT_LOCATION_COMPANYADDRESS ?? '',
  Location: process.env.REACT_APP_ENDPOINT_LOCATION ?? '',
  SiteType: process.env.REACT_APP_ENDPOINT_SITE_TYPE ?? '',
  Business: process.env.REACT_APP_ENDPOINT_BUSINESS ?? '',
  SupplierTag: process.env.REACT_APP_ENDPOINT_SUPPLIER_TAG ?? '',
  PersonFetch: process.env.REACT_APP_ENDPOINT_PERSON_FETCH ?? '',
  CompanySearchByDomain: process.env.REACT_APP_ENDPOINT_COMPANY_SEARCH_BY_DOMAIN ?? '',
  SupplierRegistrationLink: process.env.REACT_APP_ENDPOINT_SUPPLIER_REGISTRATION_LINK ?? ''
};

export const config = {
  captchaSiteKey: process.env.REACT_APP_RECAPTCHA_SITEKEY ?? '6Ldf6D8aAAAAAL-1YjCKR__MaX9pABeeY35gVv2G'
};
